"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _PhotoSizeSelectLarge = _interopRequireDefault(require("@material-ui/icons/PhotoSizeSelectLarge"));
var _classnames = _interopRequireDefault(require("classnames"));
var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      background: "rgba(0,0,0,0.05)"
    },
    item: {
      "&:hover": {
        background: theme.palette.primary.light
      }
    },
    active: {
      background: theme.palette.primary.main
    },
    img: {
      background: "rgba(255,255,255,0.2)"
    },
    icon: {
      color: "white"
    },
    titleBar: {
      background: "linear-gradient(to bottom, rgba(0,0,0,0.0) 0%, " + "rgba(0,0,0,0.2) 30%, rgba(0,0,0,0.4) 100%)"
    },
    titleBarTop: {
      background: "transparent"
    }
  };
});
function MediaSelector(_ref) {
  var medias = _ref.medias,
    selected = _ref.selected,
    setSelected = _ref.setSelected,
    cols = _ref.cols,
    onClick = _ref.onClick,
    actionIcon = _ref.actionIcon,
    min = _ref.min,
    max = _ref.max;
  var _useStyles = useStyles(),
    root = _useStyles.root,
    item = _useStyles.item,
    img = _useStyles.img,
    icon = _useStyles.icon,
    titleBarTop = _useStyles.titleBarTop,
    active = _useStyles.active;
  var unSelect = function unSelect(media) {
    setSelected(_toConsumableArray(selected.filter(function (s) {
      return s.id !== media.id;
    })));
  };
  var select = function select(media) {
    setSelected([].concat(_toConsumableArray(selected), [media]));
  };
  var isSelected = function isSelected(tile) {
    return (selected || []).filter(function (s) {
      return s === null || s === void 0 ? void 0 : s.id;
    }).map(function (s) {
      return s === null || s === void 0 ? void 0 : s.id;
    }).indexOf(tile.id) >= 0;
  };
  return /*#__PURE__*/_react["default"].createElement(_core.GridList, {
    cellHeight: cols < 3 ? 160 : 110,
    cols: cols,
    className: root,
    spacing: 8
  }, (medias ? _toConsumableArray(medias) : []).filter(function (m) {
    return m.mediaFiles && m.mediaFiles.length > 0;
  }).sort(function (a, b) {
    return new Date(b.createdAt) - new Date(a.createdAt);
  }).map(function (tile, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.GridListTile, {
      className: (0, _classnames["default"])(item, _defineProperty({}, active, isSelected(tile))),
      key: tile.id || i,
      cols: 1
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: img,
      src: tile.mediaFiles[0].path,
      loading: "lazy"
    }), /*#__PURE__*/_react["default"].createElement(_core.GridListTileBar, {
      className: titleBarTop,
      titlePosition: "bottom",
      actionIcon: onClick && (onClick === null || onClick === void 0 ? void 0 : onClick.length) > 0 ? onClick.map(function (fn, i) {
        return /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
          className: icon,
          onClick: function onClick() {
            return fn(tile);
          }
        }, actionIcon && actionIcon[i] ? actionIcon[i] : /*#__PURE__*/_react["default"].createElement(_PhotoSizeSelectLarge["default"], null));
      }) : isSelected(tile) ? selected.length > min && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
        className: icon,
        onClick: function onClick() {
          return unSelect(tile);
        }
      }, /*#__PURE__*/_react["default"].createElement(_HighlightOff["default"], null)) : selected.length < max && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
        className: icon,
        onClick: function onClick() {
          return select(tile);
        }
      }, actionIcon && actionIcon.length > 0 ? actionIcon[0] : /*#__PURE__*/_react["default"].createElement(_PhotoSizeSelectLarge["default"], null))
    }));
  }));
}
MediaSelector.propTypes = {
  cols: _propTypes["default"].number,
  medias: _propTypes["default"].arrayOf(_propTypes["default"].object),
  selected: _propTypes["default"].arrayOf(_propTypes["default"].object),
  onClick: _propTypes["default"].arrayOf(_propTypes["default"].func),
  actionIcon: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),
  min: _propTypes["default"].number,
  max: _propTypes["default"].number
};
MediaSelector.defaultProps = {
  cols: 3,
  selected: [],
  min: 0,
  max: 100
};
var _default = exports["default"] = MediaSelector;